module.exports = __webpack_public_path__ + "assets/img/icon_android.5d771352.svg";